import { Dialog, Tab, Tabs, createTheme } from "@mui/material";
import React, {
  FunctionComponent,
  SyntheticEvent,
  useContext,
  useEffect,
  useState,
} from "react";
import styles from "../Tickets/Tickets.module.css";
import { ThemeProvider } from "@emotion/react";
import { useLazyQuery } from "@apollo/client";
import { globalContext } from "../../Provider/AppProvider";
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";
import { CustomPaperComponent, getFormattedDate, roles } from "../../helper";
import images from "../../assets/images";
import PriceSetUp from "../PriceSetUp/PriceSetUp";
import AppVersion from "./AppVersion";
import TopUp from "./TopUp";
import TeamUpdate from "./TeamUpdate";
import Reminder from "./Reminder";
import AddTickets from "../AddTickets/AddTickets";
import EventsUpdate from "../EventsUpdate/EventsUpdate";
import VenueUpdate from "../VenueUpdate/VenueUpdate";
import SuperUserUpdate from "../SuperUserUpdate/SuperUserUpdate";

const Settings: FunctionComponent = () => {
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('errorTabIndex');
  const tab=localStorage?.getItem('settingsTabIndex');
  const [activeTab, setActiveTab] = useState(localStorage.getItem('settingsTabIndex')&&tab?parseInt(tab):0);
  const { handleGlobalState, globalState } = useContext<any>(globalContext);
  const StyledComponent = CustomPaperComponent();

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempData)
    }
  })

  useEffect(() => {
    const date = getFormattedDate(new Date());
    const tempvariable = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempvariable.globalSearch.searchtext = "";
      tempvariable.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      tempvariable.notification.notificationClicked = false;
      tempvariable.notification.tp_id_array=null;
      tempvariable.globalSearch.searchtext = "";
      tempvariable.notification.text = "";
      tempvariable.notification.ticketId =null;
      tempvariable.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempvariable.error.errorClicked = false;
      tempvariable.globalSearch.searchtext = "";
      tempvariable.error.text = "";
      tempvariable.error.approximateTpArray = null
      tempvariable.error.ticketPlacementId = null
      tempvariable.error.status = ""
    }else if(globalState.soldTickets.failed){
      tempvariable.soldTickets.failed = false
      tempvariable.globalSearch.searchtext = "";
      tempvariable.soldTickets.emailId = "";
    }
    handleGlobalState(tempvariable)
    getWebNotification({
      variables:{
        todayDate: date,
        userId: globalState?.profile?.id
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSettingsTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    localStorage.setItem('settingsTabIndex',String(newValue));
  };
  const theme = createTheme({
    palette: {
      primary: {
        main: "#5D75F8",
      },
    },
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: "Glegoo",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "capitalize",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className={styles.maincontainer}>
        <div className={styles.settingsContainer}>
          <div className={styles.SettingsTabsStyle}>
            <Tabs value={activeTab} onChange={handleChangeSettingsTab}>
            {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && <Tab label="Add Tickets - Manually" />}
              <Tab label = "Team Update"/>
              {globalState.profile.userRole==="admin" && <Tab label="Price Set Up" />}
              {globalState.profile.userRole==="admin" && <Tab label = "App Version"/>}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && <Tab label = "Events Update"/>}
              {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN) && <Tab label = "Venue Update"/>}
              {globalState.profile.userRole==="admin" && <Tab label = "Super User Update"/>}
              {/* Commented the Reminder Tab, Since we are moved to the scheduler concept */}
              {/* {globalState.profile.userRole==="admin" && <Tab label = "Reminder"/>} */}
              {/* {((!process.env.REACT_APP_FRONTEND_URL?.includes('staging-admin')) && globalState.profile.userRole==="admin") && <Tab label="Top Up"/>} */}
            </Tabs>
          </div>
        </div>
  
        {activeTab === 0 && (   
          <AddTickets />   
        )}
        {activeTab === 1 && (   
          <TeamUpdate/>   
        )}
        {
          (activeTab === 2 && globalState.profile.userRole==="admin") &&(
            <PriceSetUp
           activeTab = {activeTab}
          />
          )
        }
        {
          (activeTab === 3 && globalState.profile.userRole==="admin") && (
            <AppVersion/>
          )
        }
        {   
          ((activeTab === 2 && globalState.profile.userRole === roles.AFFILIATER_ADMIN) || (activeTab === 4 && globalState.profile.userRole==="admin")) && (
            <EventsUpdate/>
          )
        }
         {
          ((activeTab === 3 && globalState.profile.userRole === roles.AFFILIATER_ADMIN) || (activeTab === 5 && globalState.profile.userRole==="admin")) && (
            <VenueUpdate/>
          )
        }

        {
          (activeTab === 6 && globalState.profile.userRole==="admin") && (
            <SuperUserUpdate/>
          )
        }

        {/* Commented the Reminder Tab, Since we are moved to the scheduler concept */}
        {/* {
          (activeTab === 3 && globalState.profile.userRole==="admin") && (
            <Reminder/>
          )
        } */}
        {/* {
        (activeTab === 4 && globalState.profile.userRole==="admin" && !process.env.REACT_APP_FRONTEND_URL?.includes('staging-admin'))&&(
            <TopUp/>
          )
        } */}
      </div>
    </ThemeProvider>
  );
};

export default Settings;
